export function makeColorGradient(
  { frequency1, frequency2, frequency3, phase1, phase2, phase3, center, width, len })
{
  center = center === undefined ? 128 : center;
  width = width === undefined ? 127 : width;
  len = len === undefined ? 32 : len;
  frequency1 = frequency1 === undefined ? 0.3 : frequency1;
  frequency2 = frequency2 === undefined ? 0.3 : frequency2;
  frequency3 = frequency3 === undefined ? 0.3 : frequency3;
  phase1 = phase1 === undefined ? 0 : phase1;
  phase2 = phase2 === undefined ? 2 : phase2;
  phase3 = phase3 === undefined ? 3 : phase3;

  let df = 2. * Math.PI / len / frequency1;
  df *= 0.9
  let dp
  // dp = Math.PI / 1.3;
  // dp = 2.7;
  dp = Math.PI;
  // for (var i = 0; i < len; ++i)
  let red;
  let grn;
  let blu;
  const colors = [];
  let hexR;
  let hexG;
  let hexB;
  let hex;
  for (let i = len - 1; i >= 0 ; i -= 1)
  {
    red = Math.sin(df * (frequency1 * i) + phase1 + dp) * width + center;
    grn = Math.sin(df * (frequency2 * i) + phase2 + dp) * width + center;
    blu = Math.sin(df * (frequency3 * i) + phase3 + dp) * width + center;
    red = Math.floor(red);
    grn = Math.floor(grn);
    blu = Math.floor(blu);
    hexR = Number(red).toString(16).padStart(2, '0');
    hexG = Number(grn).toString(16).padStart(2, '0');
    hexB = Number(blu).toString(16).padStart(2, '0');
    hex = `#${hexR}${hexG}${hexB}`;

    colors.push({r: red, g: grn, b: blu, hex});
    // console.log(i, red, grn, blu);
    // document.write( `<span style="font-size: 2em; color: rgb(${red},${grn},${blu})">&#9608;</span>`);
  }
  return colors;
}
// makeColorGradient(.3,.3,.3,0,2,4);
/*
const frequency1 = 0.3;
const frequency2 = 0.3;
const frequency3 = 0.3;
const phase1 = 0;
const phase2 = 2;
const phase3 = 4;
makeColorGradient({
  frequency1,
  frequency2,
  frequency3,
  phase1,
  phase2,
  phase3,
  len: 32
})
*/
